import { useEffect, useState } from "react";
import { Trophy, Medal } from "lucide-react";
import { api } from "@/lib/api";
import { ChampionBadge } from "@/components/leads/ChampionBadge";
import { fmtDate } from "@/lib/format";

const RANK_TONE = ["bg-[#D96B43] text-white", "bg-[#0F382C] text-white", "bg-[#E7E2D6] text-[#0F382C]"];

const Row = ({ r, i, champ }) => (
  <div className={`flex items-center gap-3 rounded-xl px-3 py-2 ${i === 0 && r.members > 0 ? "bg-[#D96B43]/10 ring-1 ring-[#D96B43]/30" : ""}`} data-testid={`leaderboard-row-${i}`}>
    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-mono text-xs font-bold ${RANK_TONE[i] || "bg-white text-muted-foreground border border-[#E7E2D6]"}`}>{i === 0 && r.members > 0 ? <Trophy className="h-3.5 w-3.5" /> : i + 1}</span>
    <span className="flex min-w-0 flex-1 items-center gap-2"><span className="truncate font-semibold" data-testid={`leaderboard-name-${i}`}>{r.name}</span>{champ && <ChampionBadge compact testid={`leaderboard-champion-${i}`} />}</span>
    <span className="w-16 text-right"><span className="font-mono text-lg font-semibold text-[#0F382C]" data-testid={`leaderboard-members-${i}`}>{r.members}</span><span className="ml-1 text-[10px] text-muted-foreground">mem</span></span>
    <span className="hidden w-16 text-right font-mono text-sm sm:inline" data-testid={`leaderboard-customers-${i}`}>{r.customers}<span className="ml-1 text-[10px] text-muted-foreground">cust</span></span>
    <span className="w-16 text-right font-mono text-sm text-muted-foreground" data-testid={`leaderboard-calls-${i}`}>{r.calls}<span className="ml-1 text-[10px]">calls</span></span>
  </div>
);

export const LeadLeaderboard = ({ champions = [] }) => {
  const [week, setWeek] = useState(0);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/leads/leaderboard", { params: { week } }).then((r) => setData(r.data)).catch(() => {}); }, [week]);
  return (
    <div className="mb-6 rounded-2xl border border-[#E7E2D6] bg-white p-5" data-testid="lead-leaderboard">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="flex items-center gap-2 font-display text-lg font-semibold text-[#0F382C]"><Medal className="h-5 w-5 text-[#D96B43]" />{week ? "Last week's" : "This week's"} leaderboard</div>
          {data && <div className="text-xs text-muted-foreground" data-testid="leaderboard-range">{fmtDate(data.start)} – {fmtDate(data.end)} · ranked by members signed up</div>}
        </div>
        <div className="flex rounded-full border border-[#E7E2D6] p-0.5 text-xs">
          {[[0, "This week"], [1, "Last week"]].map(([w, l]) => (
            <button key={w} onClick={() => setWeek(w)} className={`rounded-full px-3 py-1 transition-colors ${week === w ? "bg-[#0F382C] text-white" : "hover:bg-[#F3EFE6]"}`} data-testid={`leaderboard-week-${w}`}>{l}</button>
          ))}
        </div>
      </div>
      {data && (data.rows.length === 0
        ? <div className="py-4 text-center text-sm text-muted-foreground" data-testid="leaderboard-empty">Add salespeople in Team to start the leaderboard.</div>
        : <div className="space-y-1">{data.rows.map((r, i) => <Row key={r.name} r={r} i={i} champ={champions.includes(r.name)} />)}</div>)}
    </div>
  );
};
